const ITEMS = [
  "Mobile Service",
  "Licensed & Insured",
  "Own Water & Power",
  "Serving HRM",
  "Since 2021",
  "1500+ Vehicles",
  "5-Star Rated",
];

export default function Marquee() {
  return (
    <section
      aria-label="Highlights"
      className="border-y border-white/[0.06] bg-[#0A0A0C]/40 overflow-hidden"
      data-testid="marquee"
    >
      <div className="flex w-max whitespace-nowrap animate-marquee py-5">
        {[...ITEMS, ...ITEMS].map((it, i) => (
          <span key={i} className="flex items-center px-8" aria-hidden={i >= ITEMS.length}>
            <span className="font-display text-lg tracking-tight text-white/80">{it}</span>
            <span className="ml-8 w-1.5 h-1.5 rounded-full bg-[#E30613]" />
          </span>
        ))}
      </div>
    </section>
  );
}
